import {
  GLOBAL_SEARCH,
  TAG_SEARCH
} from '../mutiation'

// initial state
// shape: [{ id, quantity }]
const state = {
  params: {
    keyword: '',
    page: 1,
    size: 10
  }
}

// actions
const actions = {

}

// mutations
const mutations = {
  [GLOBAL_SEARCH] (state, data) {
    console.log(data)
  },
  [TAG_SEARCH] (state, data) {
  }
}

const getters = {
  searchParams: state => state.params
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/pages/index/store/modules/search.js